import { render } from "./sell.vue?vue&type=template&id=4bede044&scoped=true"
import script from "./sell.vue?vue&type=script&lang=js"
export * from "./sell.vue?vue&type=script&lang=js"

import "./sell.vue?vue&type=style&index=0&id=4bede044&lang=scss&scoped=true"
import "./sell.vue?vue&type=style&index=1&id=4bede044&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bede044"]])

export default __exports__